import { QueryResultRow } from '@kentik/ui-shared/query/query.types';
import { Model } from 'core/model/Model';
import type UdeQueryResultsCollection from './UdeQueryResultsCollection';

export default class UdeQueryResultModel extends Model<QueryResultRow> {
  get defaults() {
    return {
      id: '',
      values: {},
      rollups: {},
      dimensions: {}
    };
  }

  get url() {
    return '';
  }

  get results() {
    if (!this.collection) {
      throw new Error('Query result not associated with a collection');
    }
    return this.collection as unknown as UdeQueryResultsCollection;
  }

  get timestamps() {
    return this.get('timestamps') || this.results.timestamps;
  }

  get values() {
    return this.get('values');
  }

  get rollups() {
    return this.get('rollups');
  }

  get dimensions() {
    return this.get('dimensions');
  }

  serialize() {
    return this.get();
  }
}
